import { LocalService } from './../../../services/storage/localService';
import { Component, OnInit,Injector } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl, FormGroup, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { RiesgoService } from '../../../services/riesgo/riesgo.service';
import { SimuladorService } from '../../../services/operaciones/simulador/simulador.service';
import { SimuladoresDetalle } from '../../../models/SimuladoresDetalle';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import {ErrorStateMatcher} from '@angular/material/core';
import * as moment from 'moment';
import Swal from "sweetalert2";
import { MessagesDates, MessagesGeneral, MessagesTitles, MessagesSimuladorAgregarDetalle } from '../../../models/messages';
import { Router } from '@angular/router';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
} from "@angular/material";
import { LoginService } from 'app/services/login/login.service';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'environments/environment';


export const MY_FORMATS  ={
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-simulador-nuevo',
  templateUrl: './simulador-nuevo.component.html',
  styleUrls: ['./simulador-nuevo.component.scss'],
  providers:[DatePipe,MessagesTitles,MessagesGeneral,MessagesDates,MessagesSimuladorAgregarDetalle, 
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class SimuladorNuevoComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Simulador=environment.LABEL_SIMULADOR;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  Id_Confirming=environment.ID_CONFIRMING;
  Id_Factoring=environment.ID_FACTORING;
  Id_Descuento=environment.ID_DESCUENTO;
  MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;
  
  varDiasMin :any;
  varDiasMax :any;
  varAdelantoMin:any;
  varAdelantoMax:any;
  varAdelantoDef:any;
  varTasaMin:any;
  varTasaMax:any;
  IGV_Porcentaje:any;
  tipoServicioElement = this.Id_Factoring;
  sumainteres : number = 0;
  comisionPeso : number = 0;
  user : any;
  // variables
  varAbrirSimuladorDetalle : boolean = false;
  varAbrirSimuladorDetalleRecibo : boolean = false;
  // TEM
  TEM :number = 0;
  TEMAutomatico :number = 0;
  // Scores
  scoreProveedor = '';
  scoreAdquirente = '';
  idEmpresa;
  serie;
  //loading
  loading : boolean = false;
  // temporales
  rucProvTemporal;
  rucAdqTemporal
  filteredProveeedor: Observable<any[]>;
  Date = new Date();
  proveedoresArr;
  Estado:string;
  monedaElement : any;
  // VARIABLE DE ERROR DE PROV/ADQ OBTENIDO 
  error1: boolean = false;
  error: boolean = false;
  // VARIABLE DE MENSAJE DEL ERROR DE PROV/ADQ OBTENIDO
  mensaje1: string;
  mensaje2: string;
  filteredAdquirentes: Observable<any[]>;
  adquirentessArr;
  rucProv = new FormControl('',[Validators.required]);
  rucAdq = new FormControl('',[Validators.required]);
  formTEM: FormGroup;
  formSimulador: FormGroup;
  simuladorDetalle : SimuladoresDetalle[] = [];
  SimuladorTotales: any = {
    VNPP : 0,
    Adelanto :  0,
    Interes :  0,
    InteresAdq :  0,
    InteresProv :  0,
    Comision :  0,
    IGV_TOTAL :  0,
    Desembolso :  0,
    Remanente :  0,
    TAI :  0,
    Campo_1 :  0,
  };

  SimuladorGeneral: any = {
    "Num_Doc_Identificacion_Prov" : "",
    "Num_Doc_Identificacion_ADQ" : "",
    "Fecha" : "",
    "Scoring_Proveedor" : "",
    "Scoring_Adquirente" : "",
    "Tipo_Comprobante" : "",
    "Fecha_Desembolso" : "",
    "Moneda" : "0",
    "Precio_Venta" : "0.00",
    "Total_Recibido" : "0.00",
    "VNPP" : "0.00",
    "TEM" : "",
    "TEM_Sistema" : "",
    "Adelanto_Porcentaje" : "",
    "Adelanto_Importe" : "0.00",
    "Interes_Importe" : "0.00",
    "Comision_Importe" : "0.00",
    "IGV_Porcentaje" : "",
    "IGV_Importe" : "0.00",
    "Desembolso_Importe" : "0.00",
    "Remanente_Importe" : "0.00",
    "TC_Compra" : "3.33",
    "TC_Venta" : "3.34",
    "Campo_1" : "3.34",
    "SimuladorDetalle" : []
    }

  SimuladorConDetalle : any = {
    simulador_detalle : [ ],
    idEmpresa : 1  
  };
  
   // PROVEEDOR OBTENIDO
   proveedor: any = {};

   // ADQUIRENTSE OBTENIDO
   adquirente: any = {};

  ObtScoreProv = {
    'idEmpresa' :1,
    'TipoEmpresa':'P',
    'Tipo_Doc_Identificacion':'R',
    "Num_Doc_Identificacion":"",      
  }

  ObtScoreAdq = {
    'idEmpresa' :1,
    'TipoEmpresa':'A',
    'Tipo_Doc_Identificacion':'R',
    "Num_Doc_Identificacion":"",     
  }
  riesgoService:RiesgoService;
  simuladorService:SimuladorService;
  loginService:LoginService;
  localService : LocalService;
  matcher = new MyErrorStateMatcher();
  constructor(private injector:Injector,
    
      private datepipe :DatePipe,
      private msgAgregarSimulador : MessagesSimuladorAgregarDetalle,
      private msgTitulos : MessagesTitles,
      private router:Router) { 
    
    this.riesgoService = this.injector.get<RiesgoService>(RiesgoService);
    this.simuladorService = this.injector.get<SimuladorService>(SimuladorService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.localService = this.injector.get<LocalService>(LocalService);
    this.varDiasMin = this.localService.getJsonValue('ParametroRechazoMin');
    this.varDiasMax = this.localService.getJsonValue('ParametroRechazoMax');
    this.varAdelantoMin = (this.localService.getJsonValue('ParametroAdelantoMinimo') * 100);
    this.varAdelantoMax = (this.localService.getJsonValue('ParametroAdelantoMaximo') * 100);
    this.varAdelantoDef = (this.localService.getJsonValue('ParametroAdelandoDefault') * 100);
    this.varTasaMin = this.localService.getJsonValue('ParametroTasaMinimoComercial');
    this.varTasaMax = this.localService.getJsonValue('ParametroTasaMaximo');
    this.IGV_Porcentaje = this.localService.getJsonValue('ParametroIGVPorcentaje');
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));    

    let now = moment();
    this.formTEM = new FormGroup({
      'Plazo' : new FormControl(),
      'VNPP' : new FormControl(),
      'ProveedorScore' : new FormControl(''),
      'AdquirenteScore' : new FormControl(''),
      'Num_Doc_Identificacion_Prov' : new FormControl(''),
      'Num_Doc_Identificacion_ADQ' : new FormControl(''),
      'ValorTipoCambio' : new FormControl(3.33),
      'TipoCambio' : new FormControl(this.Label_id_soles),
      'Adelanto_Porcentaje' : new FormControl(this.varAdelantoDef,[Validators.required,Validators.pattern('^[0-9.]+$'), Validators.minLength(2)]),
      'Tipo_Comprobante' : new FormControl('F'),
      'Fecha_Desembolso' : new FormControl(now),
      'Interes_Adquirente' : new FormControl(0,[Validators.pattern('^[0-9.]+$')]),
      'Tipo_Servicio':new FormControl(this.Id_Factoring,[Validators.required]),   
      'comisionAdq' : new FormControl(0),
      'Comision': new FormControl(0),
      'Comision_Porcentaje': new FormControl(0), 
      'Otros': new FormControl(0) , 
      'Campo_1': new FormControl(0) 
      
    });
    
    this.formSimulador = new FormGroup({
      Fecha :new FormControl(''),
      VNPP :new FormControl(''),
      Tipo_Comprobante : new FormControl(''),
      Fecha_Desembolso :new FormControl(''),
      Moneda :new FormControl(''),
      TEM :new FormControl(''),
      Adelanto_Porcentaje :new FormControl(''),
      Adelanto_Importe :new FormControl(''),
      Interes_Importe :new FormControl(''),
      Comision_Importe :new FormControl(''),
      IGV_Importe :new FormControl(''),
      Desembolso_Importe :new FormControl(''),
      Remanente_Importe :new FormControl(''),
      Num_Doc_IdentificacionP:new FormControl(''),
      Num_Doc_IdentificacionA:new FormControl(''),
    });
  }

  ngOnInit() {
    this.ObtenerAdquirentesCombo();
    this.ObtenerProveedoresCombo();
    this.monedaElement = this.Label_id_soles;
  }

  tipoMoneda(event){
    if(event==''){
      this.formTEM.controls['TipoCambio'].setValue(0);
    }else{ 
      this.formTEM.controls['TipoCambio'].setValue(event);
    }  
  }
  calcularComision(){
    let porcentaje = this.formTEM.controls['Comision_Porcentaje'].value;
    let comision = this.SimuladorTotales.VNPP * porcentaje/100;
    console.log(porcentaje,comision);
    this.formTEM.controls['Comision'].setValue(Math.round(comision*100)/100);
  }
  calcularPorcentaje(){
    let comision = this.formTEM.controls['Comision'].value;
    let porcentaje = comision/this.SimuladorTotales.VNPP *100;
    console.log(porcentaje,comision);
    this.formTEM.controls['Comision_Porcentaje'].setValue(Math.round(porcentaje*100)/100);
  }
  calcularTasaAllIn(){
    let comision = this.formTEM.controls['Comision'].value; 
    let tasaArray = Array();
    let i = 0;
    this.simuladorDetalle.forEach(element => {
      console.log("Comision",(((Number(element.VNPP)/this.SimuladorTotales.VNPP)*this.SimuladorTotales.Comision)));
      console.log("IGV",element.Interes);
      console.log("VNPP",element.VNPP);
      console.log("Plazo",element.Plazo);
      console.log("Calc",((((Number(element.VNPP)/this.SimuladorTotales.VNPP)*this.SimuladorTotales.Comision)+element.Interes)/Number(element.VNPP))/element.Plazo *30*100);
      tasaArray[i] = ((((Number(element.VNPP)/this.SimuladorTotales.VNPP)*this.SimuladorTotales.Comision)+element.Interes)/Number(element.VNPP))/element.Plazo *30*Number(element.VNPP);
      i++;
    });
    console.log("TasaArrays",tasaArray);
    
    let totalAll = 0;
    tasaArray.forEach( element =>{
      totalAll+=element
    })
    console.log("TotalAll",totalAll);
    console.log("TotalVNPP",this.SimuladorTotales.VNPP);
    let tasa = totalAll/this.SimuladorTotales.VNPP*100;
    console.log("TasaCAlculadaAllin",tasa);
    this.SimuladorTotales.TAI= Math.round(tasa*100)/100;
  }
  estadoSwitch(event){
    if(event.checked){
      //Prod & Adq
      this.formTEM.controls['Num_Doc_Identificacion_Prov'].setValue('00000000000');
      this.formTEM.controls['Num_Doc_Identificacion_ADQ'].setValue('00000000000');
      this.rucProv.setValue('-');
      this.rucAdq.setValue('-');
      this.ObtScoreAdq.Num_Doc_Identificacion = '0000000000';
      this.ObtScoreProv.Num_Doc_Identificacion = '0000000000';
      this.rucProv.disable();
      this.rucAdq.disable();
      this.formTEM.controls['ProveedorScore'].setValue('0');
      this.formTEM.controls['AdquirenteScore'].setValue('0');

    } else {
      this.formTEM.controls['Num_Doc_Identificacion_Prov'].setValue('');
      this.formTEM.controls['Num_Doc_Identificacion_ADQ'].setValue('');
      this.ObtScoreAdq.Num_Doc_Identificacion='';
      this.ObtScoreProv.Num_Doc_Identificacion='';
      this.rucProv.setValue('');
      this.rucAdq.setValue('');
      this.rucProv.enable();
      this.rucAdq.enable();
      //ranking
      this.formTEM.controls['ProveedorScore'].setValue('');
      this.formTEM.controls['AdquirenteScore'].setValue('');
    }
  }
  tipoServicio(event){
    this.formTEM.controls['Tipo_Servicio'].setValue(event);
    
    if(this.formTEM.controls.Tipo_Servicio.value == this.Id_Factoring || this.formTEM.controls.Tipo_Servicio.value == this.Id_Descuento){
      this.formTEM.controls['Interes_Adquirente'].setValue('0');
      this.formTEM.controls['comisionAdq'].setValue('0');
    }else{
      this.formTEM.get('Adelanto_Porcentaje').setValue(100)
      this.formTEM.get('Interes_Adquirente').setValue(100)
    }
  }
  FacturaRecibo(){
      if (this.formTEM.controls['Tipo_Comprobante'].value == 'F'){
      this.varAbrirSimuladorDetalle = true;
      this.varAbrirSimuladorDetalleRecibo = false;
    }else{
      this.varAbrirSimuladorDetalle = false;
      this.varAbrirSimuladorDetalleRecibo = true;
    }
    }
  diferenciaEntreDiasEnDias(a, b) {
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return  Math.floor((utc1 - utc2) / this.MILISENGUNDOS_POR_DIA);
  }
  eliminarItem(i : number){
      this.simuladorDetalle.splice(i,1);
      this.eliminarCalculos();
  }
  eliminarCalculos(){
    this.SimuladorTotales = {
      VNPP : 0,
      Adelanto :  0,
      Interes :  0,
      InteresAdq :  0,
      InteresProv :  0,
      Comision :  0,
      IGV_TOTAL :  0,
      Desembolso :  0,
      Remanente :  0,
    };
    this.SimuladorConDetalle.simulador_detalle.lenght = 0;
    this.TEM = 0;
    this.simuladorDetalle.forEach(item =>{
      item.Adelanto = 0;
        item.Interes = 0;
        item.Comision = 0;
        item.IGV = 0;
        item.Desembolso = 0;
        item.Remanente = 0;    
    })
    if (this.simuladorDetalle.length > 0){
      this.obtenerTEM();
    }
  }
  elimarCalculosPorCambioFecha(event){
    this.SimuladorTotales = {
      VNPP : 0,
      Adelanto :  0,
      Interes :  0,
      InteresAdq :  0,
      InteresProv :  0,
      Comision :  0,
      IGV_TOTAL :  0,
      Desembolso :  0,
      Remanente :  0,
    };
    this.simuladorDetalle.forEach(item =>{
      item.Plazo =  this.diferenciaEntreDiasEnDias(item.Fecha_de_Pago['_d'],this.formTEM.controls['Fecha_Desembolso'].value._d);
      item.Adelanto = 0;
      item.Interes = 0;
      item.Comision = 0;
      item.IGV = 0;
      item.Desembolso = 0;
      item.Remanente = 0;
    })
    this.Factoring();
  }
  editarTEM(){
    this.loading = true;
    Swal.fire({
      title: 'Ingresar TEM',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      cancelButtonText :'Cancelar',
      confirmButtonText: 'Cambiar',
      reverseButtons:true,
      showLoaderOnConfirm: true,
      allowOutsideClick : false,
      heightAuto: false,
      
    }).then((result) => {
      this.loading = false;
      if (result.dismiss) {
        return;
      }
      if (result.value < this.varTasaMin*100 || result.value > this.varTasaMax*100) {
        Swal.fire({
          title: `${this.msgTitulos.Error_Fuera_Rango}`,
          text:`${this.msgAgregarSimulador.Error_TEM}`,
          heightAuto: false
        })
        return;
      }
      this.TEM = result.value/100;
        this.Factoring();
    }, (err: HttpErrorResponse) => {
      this.loading = false;
      if(err.error.code == 500){
        err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
      }
      Swal.fire({
        title: "Ha ocurrido un error",
        text: err.error.error,
        type: "error",
        allowOutsideClick: false,
        heightAuto: false
      });
    })
  }
  MetCerrarsimuladorDetalle(){
    this.varAbrirSimuladorDetalle = false;
    this.varAbrirSimuladorDetalleRecibo = false;
  }
  RecibirsimuladorDetalle(event){
    this.simuladorDetalle.push(event);
    this.varAbrirSimuladorDetalle = false;
    this.varAbrirSimuladorDetalleRecibo = false;
    this.obtenerTEM();
  }
  guardarSimulador(){
    this.SimuladorTotales.SimuladorDetalle = [];
    this.SimuladorTotales.VNPP = this.SimuladorTotales.VNPP.toFixed(2);
    this.SimuladorTotales.Comision_Importe = this.SimuladorTotales.Comision.toFixed(2);
    this.SimuladorTotales.IGV_Importe = this.SimuladorTotales.IGV_TOTAL.toFixed(2);
    this.SimuladorTotales.Desembolso_Importe = this.SimuladorTotales.Desembolso.toFixed(2);
    this.SimuladorTotales.Remanente_Importe = this.SimuladorTotales.Remanente.toFixed(2);
    this.SimuladorTotales.Adelanto_Importe = this.SimuladorTotales.Adelanto.toFixed(2);
    this.SimuladorTotales.Interes_Importe = this.SimuladorTotales.Interes.toFixed(2);
    
    this.SimuladorTotales.Fecha = this.datepipe.transform(new Date(),'yyyy-MM-dd hh:mm:ss');
    this.SimuladorTotales.Adelanto_Porcentaje = this.formTEM.controls['Adelanto_Porcentaje'].value/100;
    this.SimuladorTotales.Tipo_Comprobante = this.formTEM.controls['Tipo_Comprobante'].value;
    this.SimuladorTotales.Moneda = this.formTEM.controls['TipoCambio'].value;
    this.SimuladorTotales.Fecha_Desembolso = this.datepipe.transform(this.formTEM.controls['Fecha_Desembolso'].value,'yyyy-MM-dd');

    this.SimuladorTotales.Num_Doc_Identificacion_Prov = this.formTEM.controls['Num_Doc_Identificacion_Prov'].value;
    this.SimuladorTotales.Num_Doc_Identificacion_ADQ = this.formTEM.controls['Num_Doc_Identificacion_ADQ'].value;
    this.SimuladorTotales.Scoring_Proveedor = this.formTEM.controls['ProveedorScore'].value;
    this.SimuladorTotales.Scoring_Adquirente = this.formTEM.controls['AdquirenteScore'].value;
    this.SimuladorTotales.Tipo_Comprobante = this.formTEM.controls['Tipo_Comprobante'].value;
    this.SimuladorTotales.TEM = this.TEM.toFixed(4);
    this.SimuladorTotales.TEM_Sistema = this.TEMAutomatico.toFixed(4);
    
    this.SimuladorTotales.Tipo_Servicio = this.formTEM.controls['Tipo_Servicio'].value;
    this.SimuladorTotales.Porcentaje_Interes_Adquirente = this.formTEM.controls['Interes_Adquirente'].value/100;
    this.SimuladorTotales.Alta_Usuario = this.user.Usuario;

    for(let item of this.simuladorDetalle){
      let fecha =this.datepipe.transform(item.Fecha_de_Pago,'yyyy-MM-dd');
      let array : any = item;
      array.Fecha_de_Pago = fecha;
      this.SimuladorTotales.SimuladorDetalle.push(array);
    }
    if(this.formTEM.controls.Tipo_Servicio.value == this.Id_Factoring || this.formTEM.controls.Tipo_Servicio.value == this.Id_Descuento){
      this.SimuladorTotales.Porcentaje_Interes_Adquirente = 0
    }
    Swal.fire({
      title: "Espere",
      text: "Guardado Información",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();   
    this.simuladorService.guardarSimulador(this.SimuladorTotales)
    .subscribe( resp => {
      let simulador = resp;
      Swal.fire({
        title: "Success",
        text: this.Label_Simulador+" registrado correctamente. ¿Descargar "+this.Label_Simulador+"?",
        type: "success",
        showCancelButton: true,
        confirmButtonText: 'Si, en PDF',
        cancelButtonText: 'No.',
        reverseButtons: true,
        allowOutsideClick: false,
        heightAuto: false
      }).then(resp1 => {
        if (resp1.value == true) {
         this.loginService.clickGuard = true;    
         window.open(simulador['Url_Simulador'], "_blank");
         window.open(simulador['UrlResumen_Simulador'], "_blank");
         this.router.navigate(["/operaciones/simulador/listado"]);
        }else{     
          this.loginService.clickGuard = true;     
          this.router.navigate(["/operaciones/simulador/listado"]);
        }
      }
      );
    }, (err: HttpErrorResponse) => {
      this.loading = false;
      if(err.error.code == 500){
        err.error.error = "Problemas con el sistema, por favor contactarse con soporte"
      }
      Swal.fire({
        title: "Registrar tipo de cambio",
            text: "Coordinar con el área de contabilidad",
        allowOutsideClick: false,
        heightAuto: false
      });
    }
    );
  
}
  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.rucProv.valueChanges
    .pipe(
      startWith(""),
      map(state =>
        state ? this._filterProv(state) : this.proveedoresArr.slice()
      )
    );
  }
  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  ObtenerAdquirentesCombo() {
    this.adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.rucAdq.valueChanges
    .pipe(
      startWith(""),
      map(state =>
        state ? this._filterAdq(state) : this.adquirentessArr.slice()
      )
    );
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentessArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }


  calcularPlazoMaximoSumaImporte(){
    let plazo :number[] = [];
    let sumaVNPP :number = 0;
    let TotalAdelanto : number = 0;
    let TotalIGV : number = 0;
    let TotalInteres : number = 0;
    let TotalComision : number = 0;
    let TotalDesembolso : number = 0;
    let TotalRemanente : number = 0;

    for (let item of this.simuladorDetalle) {
      plazo.push(item.Plazo);
      sumaVNPP += Number(item.VNPP) ; 
      TotalAdelanto += Number(item.Adelanto);
      TotalIGV += Number(item.IGV);
      TotalInteres += Number(item.Interes);
      TotalComision += Number(item.Comision);
      TotalDesembolso += Number(item.Desembolso);
      TotalRemanente += Number(item.Remanente);
    }
    let plazoMaximo = Math.max(...plazo);
    this.formTEM.controls['Plazo'].setValue(plazoMaximo);
    this.formTEM.controls['VNPP'].setValue(sumaVNPP);
    this.SimuladorTotales.VNPP = sumaVNPP;
    this.SimuladorTotales.Adelanto = TotalAdelanto;
    this.SimuladorTotales.Interes = TotalInteres;
    this.SimuladorTotales.Comision = TotalComision;
    this.SimuladorTotales.IGV_TOTAL = TotalIGV;
    this.SimuladorTotales.Desembolso = TotalDesembolso;
    this.SimuladorTotales.Remanente = TotalRemanente;
    this.SimuladorTotales.Plazo = plazoMaximo;
}

  calcularTotalesImporte(){
    let sumaVNPP :number = 0;
    let TotalAdelanto : number = 0;
    let TotalIGV : number = 0;
    let TotalInteres : number = 0;
    let TotalComision : number = 0;
    let TotalDesembolso : number = 0;
    let TotalRemanente : number = 0;
    let TotalComisionTotal : number = 0;
    let TotalCavali : number = 0;
    let TotalFirma : number = 0;
    let TotalOtros : number = 0;
  
    for (let item of this.simuladorDetalle) {     

      sumaVNPP += Number(item.VNPP) ; 
      TotalAdelanto += Number(item.Adelanto);
      TotalIGV += Number(item.IGV);
      TotalInteres += Number(item.Interes);
      TotalComision += Number(item.Comision);
      TotalDesembolso += Number(item.Desembolso);
      TotalRemanente += Number(item.Remanente);    
      TotalCavali += Number(item.CAVALI_importe);    
      TotalFirma += Number(item.firma_importe);    
      TotalOtros += Number(item.otros_importe);    
      TotalComisionTotal += Number(item.Comision_importe);    
    }

    this.SimuladorTotales.VNPP = sumaVNPP;
    this.SimuladorTotales.Adelanto = TotalAdelanto;
    this.SimuladorTotales.Interes = TotalInteres;
    this.SimuladorTotales.Comision = TotalComisionTotal;
    this.SimuladorTotales.IGV_TOTAL = TotalIGV;
    this.SimuladorTotales.Desembolso = TotalDesembolso;
    this.SimuladorTotales.Remanente = TotalRemanente;  
    this.SimuladorTotales.CAVALI = TotalCavali;  
    this.SimuladorTotales.Firma = TotalFirma;  
    this.SimuladorTotales.Otros = TotalOtros; 
    this.SimuladorTotales.Campo_1 = this.formTEM.controls['Campo_1'].value;; 
    this.calcularTasaAllIn();  
  }
  obtenerTEM(){
    this.loading = true;
    this.calcularPlazoMaximoSumaImporte();
        this.simuladorService.obtenerTEM(this.formTEM.value)
        .subscribe(
          data => {
            this.TEMAutomatico = Number(data)
            this.TEM = Number(data);
            this.formSimulador.controls['TEM'].setValue(this.TEM.toFixed(4));         
            this.Factoring();         
          }, err => {
            Swal.fire({
              title: "Registrar tipo de cambio",
              text: "Coordinar con el área de contabilidad",
              allowOutsideClick: true,
              heightAuto: false
            });
            this.loading = false;
          }
        );
    
  }

  ClickEnviarRUC(ruc ,empresa:string,estado:string){
    if (empresa == 'P'){
      this.ObtScoreProv.Num_Doc_Identificacion='';
      this.ObtScoreProv.Num_Doc_Identificacion = ruc;
      this.formSimulador.controls['Num_Doc_IdentificacionP'].setValue(ruc);
      this.formTEM.controls['Num_Doc_Identificacion_Prov'].setValue(ruc);
      this.obtenerScoreProveedor();
    }else {
      this.ObtScoreAdq.Num_Doc_Identificacion='';
      this.formSimulador.controls['Num_Doc_IdentificacionA'].setValue(ruc);
      this.formTEM.controls['Num_Doc_Identificacion_ADQ'].setValue(ruc);
      this.ObtScoreAdq.Num_Doc_Identificacion = ruc;
      this.obtenerScoreAdquirente();
    }
  }

  EnterobtenerRucRazSocialProv(termino :string ,empresa:string){
    let RUCempresa = '';
    this.ObtScoreProv.Num_Doc_Identificacion='';
    if (termino != null && termino != ''){
      let termino1 = termino.toLowerCase();                   
      for( let p of this.proveedoresArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz === termino1  ){ 
          this.ObtScoreProv.Num_Doc_Identificacion = p.Num_Doc_Identificacion;
          RUCempresa =p.Num_Doc_Identificacion;
          }
      }
      this.formSimulador.controls['Num_Doc_IdentificacionP'].setValue( RUCempresa);
      this.formTEM.controls['Num_Doc_Identificacion_Prov'].setValue(RUCempresa);
      this.obtenerScoreProveedor();        
    }
  }

  EnterobtenerRucRazSocialAdq(termino :string ,empresa:string){
    let RUCempresa = '';
    this.ObtScoreAdq.Num_Doc_Identificacion = ''
    if (termino != null && termino != ''){
      let termino1 = termino.toLowerCase();                   
      for( let p of this.adquirentessArr){
          let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz ===termino1){
          RUCempresa =p.Num_Doc_Identificacion;
          this.ObtScoreAdq.Num_Doc_Identificacion = p.Num_Doc_Identificacion;
          }
        }
        this.formSimulador.controls['Num_Doc_IdentificacionA'].setValue( RUCempresa);
        this.formTEM.controls['Num_Doc_Identificacion_ADQ'].setValue(RUCempresa);
        this.obtenerScoreAdquirente();
    }
  } 

  Factoring(){
    let nroFacturas = 0;   
    
    this.simuladorDetalle.forEach((item,index)=>{
      nroFacturas++;
    });
    this.simuladorDetalle.forEach((item,index)=>{
      item.TEM = this.TEM;
         item.pPAdelanto  =  this.formTEM.controls['Adelanto_Porcentaje'].value/100;
         item.Moneda =   this.formTEM.controls['TipoCambio'].value;  
         item.Porcentaje_Interes_Adquirente = this.formTEM.controls['Interes_Adquirente'].value/100;
         item.Tipo_Servicio = this.formTEM.controls['Tipo_Servicio'].value;
         item.Comision_importe = this.formTEM.controls['Comision'].value;
         item.Otros_Descuentos = this.formTEM.controls['Otros'].value;
         item.Campo_1 = this.formTEM.controls['Campo_1'].value;
         item.nroFacturas = nroFacturas;
         item.Fecha_de_Pago_Original = item.Fecha_de_Pago;
         this.sumainteres = 0;
        this.simuladorService.factoring(item)
          .subscribe( resp => {
            
            this.simuladorDetalle[index].Adelanto = resp['Adelanto'];
            this.simuladorDetalle[index].Remanente = resp['Remanente'];
            this.simuladorDetalle[index].Desembolso = resp['Desembolso'];
            this.simuladorDetalle[index].Comision = resp['Comision'];
            this.simuladorDetalle[index].Interes = resp['Interes'];
            this.simuladorDetalle[index].InteresAdq = resp['InteresAdq'];
            this.simuladorDetalle[index].InteresProv = resp['InteresProv'];
            this.simuladorDetalle[index].IGV = resp['IGV'];
            this.simuladorDetalle[index].CAVALI_importe = resp['Timbre'];
            this.simuladorDetalle[index].firma_importe = resp['Feci'];
            this.simuladorDetalle[index].otros_importe = resp['G_cesion'];
            this.simuladorDetalle[index].Comision_importe = resp['Comision'];
            this.simuladorDetalle[index].IGVProv = resp['IGVProv'];
            this.simuladorDetalle[index].DesembolsoProvConfirming = resp['DesembolsoProvConfirming'];
            
            this.sumainteres += resp['Costo_Total_Operacion']; 
            this.formTEM.controls['comisionAdq'].setValue(Math.round(this.sumainteres*100)/100)
            this.loading = false;
            this.calcularTotalesImporte();
            /*if(this.simuladorDetalle.length == nroFacturas){
              this.SimuladorTotales.NroFacturas = nroFacturas;
              this.SimuladorTotales.Moneda = item.Moneda;           
              this.simuladorService.factoringResume(this.SimuladorTotales)
                  .subscribe( resp4 => {
                      let com = resp4;
                      this.simuladorDetalle.forEach((item2,index2)=>{
                        if(this.formTEM.controls.Interes_Adquirente.value > 0 && com['Comision_peso'] > 0){
                          let comisionPesoAdq = 0;                          
                          comisionPesoAdq = com['Comision_peso'] * (this.formTEM.controls.Interes_Adquirente.value/100)
                          this.comisionPeso = com['Comision_peso'] - comisionPesoAdq
                        }else{
                          this.comisionPeso = com['Comision_peso'];
                        }
                        this.simuladorDetalle[index2].Comision = Math.round((this.simuladorDetalle[index2].Adelanto*this.comisionPeso)*100)/100;
                        this.simuladorDetalle[index2].IGV = this.formTEM.controls['Tipo_Servicio'].value!= this.Id_Confirming?0:Math.round(((this.simuladorDetalle[index2].Interes+this.simuladorDetalle[index2].Comision)*this.IGV_Porcentaje)*100)/100;
                        this.simuladorDetalle[index2].Desembolso = Math.round((this.simuladorDetalle[index2].Adelanto-(this.simuladorDetalle[index2].Interes+this.simuladorDetalle[index2].Comision+this.simuladorDetalle[index2].IGV))*100)/100;
                        this.simuladorDetalle[index2].ComisionTotal = Math.round((this.simuladorDetalle[index2].Adelanto*com['Comision_peso'])*100)/100;
                      })
                      this.calcularTotalesImporte();
                  })
            }*/
            
            
          })  
    }) 
  
  }

  obtenerScoreProveedor(){
    this.loading = true;
    this.error1 = false;  
    this.riesgoService.obtenerScore(this.ObtScoreProv)
      .subscribe( res => {
        this.Estado = res['Estado'];
        if(this.Estado == "X" ){
          this.error1 = true;
          this.mensaje1 = this.Label_Proveedor+" bloqueado.";
          this.loading = false;
          return;
        }        
        this.formTEM.controls['ProveedorScore'].setValue(res['Scoring_Puntaje']);
        this.loading = false;
      },err =>{
        this.loading = false;

      });
  }

  obtenerScoreAdquirente(){
    this.loading = true; 
    this.riesgoService.obtenerScore(this.ObtScoreAdq)
      .subscribe( res => {
        this.Estado = res['Estado'];
        if(this.Estado == "X" ){
          this.error = true;
          this.mensaje2= this.Label_Adquirente+" bloqueado.";
          this.loading = false;
          return;
        }
        this.formTEM.controls['AdquirenteScore'].setValue(res['Scoring_Puntaje']);
        this.loading = false;
      },err =>{
        this.loading = false;

      });
  }
}
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return (control && control.invalid);
  }
}